import { ComponentView } from "binder";
import { TableView } from "../../table/table-view";
import { isString } from "../../utilities";
import { ColumnFilter } from "../columnFilter/columnFilter";
import { ExTableViewModel } from "../exTable-viewModel";
import { ColumnViewModel } from "./column-viewModel"

export class ColumnView extends ComponentView<ColumnViewModel>{
    GetViewUniqueId(): string {
        return "V-435577A0-8A42-44B7-BC0F-432830831842"
    }
    loadHtml(): string {
        let element = require('./column.html').default;
        let style = require('./column.less');
        return element;
    }
    constructor() {
       super();
    }
    append(...nodes: (Node | string)[]): void{
        if(nodes.length>0){
            if(isString(nodes[0]))
                this.name = <string>nodes[0];
            else
                this.name = (<Node>nodes[0]).textContent;
        }
    }
    attachedToView(){
        let parentTable :any = this.firstlevelElement;
        while((parentTable instanceof HTMLTableElement)==false){
            parentTable = parentTable.parentElement;
        }
        let tableDataContext: ExTableViewModel = parentTable.binderRelatedView.dataContext;
        tableDataContext.takeInColumn(this.dataContext);
    }
    public set filter(v: ColumnFilter) { this._filter = v; } public get filter(): ColumnFilter { return this._filter;} private _filter: ColumnFilter;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isSortAsc(v: boolean) { this._isSortAsc = v; } public get isSortAsc(): boolean { return this._isSortAsc;} private _isSortAsc: boolean;
    public set isSortDesc(v: boolean) { this._isSortDesc = v; } public get isSortDesc(): boolean { return this._isSortDesc;} private _isSortDesc: boolean;
    public set isNoSort(v: boolean) { this._isNoSort = v; } public get isNoSort(): boolean { return this._isNoSort;} private _isNoSort: boolean;
    public set isFiltered(v: boolean) { this._isFiltered = v; } public get isFiltered(): boolean { return this._isFiltered;} private _isFiltered: boolean;

    changeSortOrder(){
        this.dataContext.changeSortOrder();
    }
}
